document.addEventListener("DOMContentLoaded", () => {
  // トップページMVswiper 初期化
  const mvSwiper = new Swiper(".mv_wrap .swiper", {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".mv_wrap .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".mv_wrap .swiper-button-next",
      prevEl: ".mv_wrap .swiper-button-prev",
    },
  });

  // 一時停止・再生（存在チェックを追加）
  const pauseBtn = document.querySelector(".swiper_pause");
  if (pauseBtn && mvSwiper && mvSwiper.autoplay) {
    pauseBtn.addEventListener("click", function () {
      if (this.classList.contains("paused")) {
        mvSwiper.autoplay.start();
        this.classList.remove("paused");
      } else {
        mvSwiper.autoplay.stop();
        this.classList.add("paused");
      }
    });
  }

  // Member: サムネ クリック/キー操作でメイン画像切替
  const container = document.querySelector(".img_area");
  let mainImg;

  function swapImage(thumb) {
    if (!thumb || !thumb.src || !mainImg || !container) return;
    // 同一画像なら何もしない
    if (mainImg.src === thumb.src) return;
    // フェード中の多重実行を抑止
    if (mainImg.classList.contains("is-fade-out")) return;

    const nextSrc = thumb.src;
    const nextSrcset = thumb.srcset || "";
    const nextAlt = thumb.alt || "";

    // サムネのアクティブ表示
    container
      .querySelectorAll(".thumb_img")
      .forEach((el) => el.classList.remove("is-active"));
    const item = thumb.closest(".thumb_img");
    if (item) item.classList.add("is-active");

    // フェードアウト完了後にsrcを差し替え、読み込み完了でフェードイン
    const doSwap = () => {
      mainImg.removeEventListener("transitionend", doSwap);

      const onLoad = () => {
        mainImg.removeEventListener("load", onLoad);
        // 次フレームでフェードイン
        requestAnimationFrame(() => mainImg.classList.remove("is-fade-out"));
      };
      mainImg.addEventListener("load", onLoad, { once: true });

      mainImg.src = nextSrc;
      if (nextSrcset) mainImg.srcset = nextSrcset;
      else mainImg.removeAttribute("srcset");
      mainImg.alt = nextAlt;

      // キャッシュで即時completeの場合にも対応
      if (mainImg.complete) {
        requestAnimationFrame(() => mainImg.classList.remove("is-fade-out"));
      }
    };

    mainImg.addEventListener("transitionend", doSwap, { once: true });
    // フェードアウト開始
    mainImg.classList.add("is-fade-out");
  }

  if (container) {
    mainImg = container.querySelector(".main_img_area .img_fit img");
    if (!mainImg) return;

    container.addEventListener("click", (e) => {
      const thumbImg = e.target.closest(".thumb_img img");
      if (!thumbImg) return;
      e.preventDefault();
      swapImage(thumbImg);
    });

    container.addEventListener("keydown", (e) => {
      if (
        (e.key === "Enter" || e.key === " ") &&
        e.target.matches('.thumb_img img[tabindex="0"]')
      ) {
        e.preventDefault();
        swapImage(e.target);
      }
    });
  }
});
